import {
    type NormalizedUserName,
    type UserNameInput,
    normalizeUserName,
} from '../helpers/normalizeUserName';
import {
    type MaybeRefOrGetter,
    toValue,
    type ComputedRef,
    computed,
} from 'vue';

export function useNormalizedUserName(
    inputName: MaybeRefOrGetter<UserNameInput>
): ComputedRef<NormalizedUserName> {
    return computed(() => normalizeUserName(toValue(inputName)));
}
